const wowApp = require('angular').module('oly.common');

wowApp.directive('wowPostCode', [require('./post-code.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/postcode/index.js